import { type PayloadAction, createSlice } from "@reduxjs/toolkit";
import type { FilterExt } from "../../types/filters";
import { serializeError } from "../storeUtils";

interface StateType {
  filtersPending: boolean;
  filters: FilterExt[] | null;
  error: string;
}

const initialState: StateType = {
  filtersPending: false,
  filters: null,
  error: "",
};

const FiltersSlice = createSlice({
  name: "Filters",
  initialState,
  reducers: {
    hasError(state: StateType, action) {
      state.error = serializeError(action.payload);
      state.filtersPending = false;
    },
    getFiltersPending: (state) => {
      state.filtersPending = true;
    },
    getFiltersResult: (
      state,
      action: PayloadAction<{ items: FilterExt[] }>,
    ) => {
      state.filters = action.payload.items;
      state.filtersPending = false;
    },
  },
});

export const { getFiltersPending, getFiltersResult, hasError } =
  FiltersSlice.actions;

export default FiltersSlice.reducer;
